import { currencyFormatter } from '@/helpers/currencyFormatter';
import { PalmettoIcon } from '@palmetto/dsm-components';

import { CustomerDirectPaymentPage } from './CustomerDirectPaymentPage';

interface CustomerDirectPaymentSuccessProps {
  firstName: string;
  amount: number;
}

export function CustomerDirectPaymentSuccess({ firstName, amount }: CustomerDirectPaymentSuccessProps) {
  return (
    <CustomerDirectPaymentPage>
      {/* Main content — top on mobile, centered on desktop */}
      <div className="flex flex-1 items-start justify-center pt-24 lg:items-center lg:pt-40 lg:pb-40">
        <div className="flex w-full max-w-[697px] flex-col items-stretch gap-8 lg:h-[344.5px] lg:flex-row">
          {/* Success card */}
          <div
            data-theme="lumen"
            className="flex w-full flex-col justify-between gap-32 rounded-16 bg-canvas-success p-24 lg:w-[340px] lg:shrink-0"
          >
            <h2 className="heading-700 text-text-success">
              Thanks
              {firstName ? <> {firstName}!</> : '!'}
              <br />
              You&apos;re all set
            </h2>
            <PalmettoIcon name="celebrate" size="2xl" className="text-text-success" />
          </div>

          {/* Right column — confirmation copy */}
          <div className="flex flex-1 flex-col gap-16 p-24 lg:justify-center">
            <p className="body-400 text-text-secondary">
              You made a payment for <strong>{currencyFormatter.format(amount)}</strong>.
            </p>
            <p className="body-400 text-text-secondary">
              Please allow 3–5 business days for it to process and show up on your account.
            </p>
            <p className="body-400 text-text-secondary">A confirmation email has been sent to your email address.</p>
          </div>
        </div>
      </div>
    </CustomerDirectPaymentPage>
  );
}
